import { fetch } from '~/utils/fetch';
import { getAPIUrl } from '~/utils/api';

export async function getFacets({ context, query, organizationId, facet }) {
  const url = getAPIUrl({
    context,
    pathname: `/api/v2/${
      organizationId ? `organizations/${organizationId}/` : ''
    }pseas/facets${facet ? `/${facet}` : ''}`,
    query
  });
  const response = await fetch(url, { context });

  return response.json();
}

export async function search({ context, body, searchId, searchAfter }) {
  const url = getAPIUrl({
    context,
    pathname: '/api/v2/pseas/_search'
  });
  const headers = { 'Content-Type': 'application/json' };

  if (searchId) {
    headers['x-search-id'] = searchId;
  }

  if (searchAfter != null) {
    headers['x-search-after'] = Array.isArray(searchAfter)
      ? JSON.stringify(searchAfter)
      : String(searchAfter);
  }

  const response = await fetch(url, {
    context,
    method: 'POST',
    headers,
    body: JSON.stringify(body)
  });

  return response.json();
}

export async function getMinorVersionMetadata({
  context,
  groupId,
  assetId,
  minorVersion
}) {
  const normalizedVersion =
    minorVersion && !String(minorVersion).includes('.')
      ? `${minorVersion}.0`
      : minorVersion;

  const url = getAPIUrl({
    context,
    pathname: `/api/v2/pseas/assets/${groupId}/${assetId}/minorVersions/${normalizedVersion}/versions`
  });
  const response = await fetch(url, { context });

  return response.json();
}
